import React, { useState, useEffect, useRef } from 'react';
import './NewQuestModal.css';
import PlaceFields from './PlaceFields';

// `defaultCity` pre-fills the city (the open quest's); the country follows from
// the dictionary, or is asked for when the city is new.
const NewQuestModal = ({ onClose, onCreate, defaultCity = '' }) => {
  const [name, setName] = useState('');
  const [questId, setQuestId] = useState('');
  const [city, setCity] = useState(defaultCity);
  const [country, setCountry] = useState('');
  // Russian names / flag code for a place the dictionary does not know yet.
  const [names, setNames] = useState({});
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const nameRef = useRef(null);

  useEffect(() => {
    if (nameRef.current) nameRef.current.focus();
  }, []);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleSubmit = async () => {
    const trimmedName = name.trim();
    const trimmedId = questId.trim();

    if (!trimmedId) {
      setError('Specify an id for the quest.');
      return;
    }
    if (/\s/.test(trimmedId)) {
      setError('Id must not contain spaces.');
      return;
    }
    if (!city.trim()) {
      setError('Specify a city.');
      return;
    }
    if (!country.trim()) {
      setError('Specify a country for the new city.');
      return;
    }

    setSubmitting(true);
    setError('');
    try {
      await onCreate({ questName: trimmedName, questId: trimmedId, city: city.trim(), country: country.trim(), ...names });
      // onCreate closes the modal on success.
    } catch (err) {
      setError(err.message || 'Failed to create the quest.');
      setSubmitting(false);
    }
  };

  return (
    <div className="new-quest-overlay" onMouseDown={onClose}>
      <div className="new-quest-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <h2>New Quest</h2>

        <label className="new-quest-field">
          <span className="new-quest-label">Name</span>
          <input
            ref={nameRef}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Unordinary Istanbul"
          />
        </label>

        <label className="new-quest-field">
          <span className="new-quest-label">Id <small>(no spaces)</small></span>
          <input
            type="text"
            value={questId}
            onChange={(e) => { setQuestId(e.target.value); setError(''); }}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
            placeholder="unordinary-istanbul"
            spellCheck={false}
            autoCapitalize="off"
            autoCorrect="off"
          />
        </label>

        <PlaceFields
          city={city}
          country={country}
          onCityChange={(v) => { setCity(v); setError(''); }}
          onCountryChange={(v) => { setCountry(v); setError(''); }}
          names={names}
          onNamesChange={(patch) => { setNames(n => ({ ...n, ...patch })); setError(''); }}
        />

        {error && <div className="new-quest-error">{error}</div>}

        <div className="new-quest-actions">
          <button onClick={onClose} className="new-quest-cancel" disabled={submitting}>
            Cancel
          </button>
          <button onClick={handleSubmit} className="new-quest-create" disabled={submitting}>
            {submitting ? 'Creating…' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewQuestModal;
